import e from"react";var t=function(t){var r=t.href,i=t.testId,a=t.children;return e.createElement("a",{href:r,"data-testid":i,className:"text-action-primary inline text-inherit font-medium hover:underline"},a)};t.displayName="Link";export{t as Link};
//# sourceMappingURL=Link.js.map
